// extracted by mini-css-extract-plugin
export default {"userData":"CurrentUserMenu_userData__-P1hT","userMenuBtn":"CurrentUserMenu_userMenuBtn__ilKlQ","userName":"CurrentUserMenu_userName__dH0aw"};